import React from 'react';
import ReviewList from 'component/page/detail/Review/ReviewList/ReviewList';
import ReviewDistribution from 'component/page/detail/Review/ReviewDistribution/ReviewDistribution';
import ReviewSortFilterChips from 'component/page/detail/Review/ReviewSortAndFilter/ReviewSortFilterChips';

interface ReviewListContainerProps {
    isInOverlay?: boolean;
}
const ReviewListContainer: React.FC<ReviewListContainerProps> = (props) => (
    <>
        <ReviewDistribution />
        <ReviewSortFilterChips />
        <ReviewList isInOverlay={props.isInOverlay} />
    </>
);

ReviewListContainer.displayName = 'ReviewListContainer';
export default ReviewListContainer;
